import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  ApplicationState,
  getAvailableSpeed,
  getAvailableSpeedPending,
  getAvailableSpeedTechnicalError,
} from '../../../../store/reducers';
import { GetAvailableSpeed } from '../../../../store/actions/available-speed.actions';
import {
  AvailableSpeed,
  AvailableSpeedResource,
  Product,
} from '@dch/products-business-logic';
import { OnDestroyHookDirective } from '../../../../shared/hooks';
import { TranslationService } from '@proximus/ng-common';

@Component({
  selector: 'mprd-available-speed',
  templateUrl: './available-speed.component.html',
})
export class AvailableSpeedComponent
  extends OnDestroyHookDirective
  implements OnChanges, OnInit
{
  @Input() product: Product;
  availableSpeed: AvailableSpeedResource;
  hasError: boolean;
  isPending: boolean;

  constructor(
    private store: Store<ApplicationState>,
    private translationService: TranslationService,
  ) {
    super();
  }

  ngOnInit(): void {
    this.addSubscription(
      this.store.select(getAvailableSpeed).subscribe((value) => {
        this.availableSpeed = value;
      }),
    );
    this.addSubscription(
      this.store.select(getAvailableSpeedTechnicalError).subscribe((value) => {
        this.hasError = !!value;
      }),
    );
    this.addSubscription(
      this.store.select(getAvailableSpeedPending).subscribe((value) => {
        this.isPending = value;
      }),
    );
  }

  ngOnChanges() {
    if (this.product && this.product.accessNumber) {
      this.store.dispatch(
        new GetAvailableSpeed({ serviceId: this.product.accessNumber }),
      );
    }
  }

  getCounterUnitLabel(speed: AvailableSpeed) {
    if (speed) {
      if (speed.unit === 'Mbps') {
        return this.translationService.getTranslatedValueFor(
          'internet.availableSpeed.countersUnitInfo.counterUnit.mbps.label',
        );
      } else if (speed.unit === 'Kbps') {
        return this.translationService.getTranslatedValueFor(
          'internet.availableSpeed.countersUnitInfo.counterUnit.kbps.label',
        );
      }
    }
  }
}
